import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
// import BitPayLogo from '@assets/images/BitPayLogoFooter.svg'
import { isGiftCardSelected } from '@helpers/checkout/global'

const padding = 78

const Discover = props => {
  const { index, cordY } = props
  return (
    <g data-testid="discover" transform={`translate(${padding * index},${cordY}) scale(0.963)`}>
      <path
        fill="#384b5e"
        d="M76.7 45.7c0 1.1-.5 2.2-1.3 3s-1.9 1.3-3 1.3H8.6c-2.4 0-4.3-1.9-4.3-4.3V4.4c0-1.1.5-2.2 1.3-3S7.5.1 8.6.1h63.7c1.1 0 2.2.5 3 1.3s1.3 1.9 1.3 3v41.3z"
      />
      <path
        fill="#f37026"
        d="M48 24.9c0-1.4-.5-2.8-1.5-3.8s-2.3-1.5-3.8-1.5c-2.1 0-4.1 1.3-4.9 3.3-.8 2-.4 4.3 1.2 5.8 1.5 1.5 3.8 2 5.8 1.2s3.2-2.8 3.2-5c0 .1 0 0 0 0z"
      />
      <path
        fill="#e7e8e3"
        d="M36.4 27.3c-.8.8-1.5 1.1-2.3 1.1-1.9 0-3.3-1.4-3.3-3.5 0-1 .4-1.9 1-2.6.6-.6 1.4-.9 2.2-.9.9 0 1.6.3 2.5 1.1v-2.3c-.8-.4-1.6-.6-2.5-.6-1.3.1-2.5.6-3.5 1.4-1.1 1-1.8 2.5-1.8 4 0 3 2.3 5.2 5.3 5.2h.1c.8 0 1.5-.2 2.5-.6l-.2-2.3c.1 0 .1.1 0 0zm18.3-6.2l-2.3 5.7-2.7-6.7h-2.1l4.2 10.3h1.1l4.4-10.3h-2.2l-.4 1zm3.4 3.5v5.5h5.6v-1.7h-3.6v-2.7h3.5v-1.8h-3.5v-2.1h3.6V20h-5.6v4.6zm-43.8 3c-.6.5-1.4.8-2.7.8H11v-6.6h.5c1.2 0 2 .2 2.7.8.7.6 1.1 1.5 1.1 2.5.1.8-.3 1.8-1 2.5zm-2.4-7.5H9.1v10H12c1.5 0 2.7-.4 3.6-1.1 1.2-1 1.8-2.4 1.8-3.9 0-3-2.2-5-5.5-5zm6.4 0h1.9v10h-1.9v-10zm6.8 3.8c-1.2-.4-1.5-.7-1.5-1.2 0-.6.6-1.1 1.4-1.1.6 0 1.1.2 1.6.8l1-1.3c-.8-.7-1.9-1.1-3-1.1-1.7 0-3.2 1.2-3.2 2.9 0 1.4.6 2 2.5 2.8.8.3 1.1.4 1.3.6.4.2.6.6.6 1 0 .8-.6 1.4-1.5 1.4s-1.7-.5-2.1-1.3L21 28.6c.9 1.3 2 1.9 3.5 1.9 2 0 3.5-1.3 3.5-3.3 0-1.7-.6-2.4-2.9-3.3zm42.5.7H67v-3.1h.6c1.2 0 1.9.5 1.9 1.5s-.7 1.6-1.9 1.6zm1.6 1.3c1.5-.3 2.3-1.3 2.3-2.9 0-1.8-1.3-3-3.6-3h-3v10h1.9v-4h.5l2.8 4h2.3l-3.2-4.1z"
      />
      <path
        fill="#374555"
        d="M7.3 45.6V4.3c0-2.4 2-4.3 4.3-4.3h-3c-1.1 0-2.2.5-3 1.3s-1.3 1.9-1.3 3v41.3c0 1.1.5 2.2 1.3 3s1.9 1.3 3 1.3h3c-2.3 0-4.3-1.8-4.3-4.3z"
      />
    </g>
  )
}

Discover.propTypes = {
  cordY: PropTypes.any,
  index: PropTypes.any,
}

const MasterCard = props => {
  const { index, cordY } = props
  return (
    <g data-testid="mastercard" transform={`translate(${padding * index},${cordY}) scale(0.963)`}>
      <path
        fill="#e92328"
        d="M30.9 24.9c0-7.7 3.5-14.9 9.6-19.7-7.5-5.9-17.8-7-26.4-2.8S0 15.3 0 24.9s5.5 18.3 14.1 22.5 18.9 3.1 26.4-2.8c-6.1-4.7-9.6-12-9.6-19.7z"
      />
      <path
        d="M81 24.9c0 9.6-5.5 18.3-14.1 22.5S48 50.5 40.5 44.6c6-4.7 9.6-12 9.6-19.7S46.6 10 40.5 5.2c7.5-5.9 17.8-7 26.4-2.8S81 15.3 81 24.9zM80.2 40.4v-1H80l-.3.7-.3-.7h-.3v1h.1v-.7l.3.6h.2l.3-.6v.7zM78.6 40.4v-.8h.3v-.2h-.8v.2h.3v.8z"
        fill="#f59e21"
      />
      <ellipse cx="40.5" cy="24.9" fill="#f26324" rx="9.6" ry="19.7" />
    </g>
  )
}

MasterCard.propTypes = {
  cordY: PropTypes.any,
  index: PropTypes.any,
}

const Visa = props => {
  const { index, cordY } = props
  return (
    <g data-testid="visa" transform={`translate(${padding * index},${cordY}) scale(0.963)`}>
      <path
        fill="#d68c28"
        d="M8.2 50h64.4c1.1 0 2.2-.5 3-1.3.8-.8 1.3-1.9 1.3-3v-4.4H4v4.4c0 1.1.5 2.2 1.3 3 .7.8 1.8 1.3 2.9 1.3z"
      />
      <path fill="#dfdfde" d="M4 8.7h73v32.6H4z" />
      <path
        fill="#138aa7"
        d="M72.8 0H8.3c-1.1 0-2.2.5-3 1.3S4 3.2 4 4.3v4.4h73V4.3c0-1.1-.5-2.2-1.3-3C75 .5 73.9 0 72.8 0z"
      />
      <path fill="#fff" d="M7 8.7h70v32.6H7z" />
      <path d="M20.3 25.4l-1.7-8.1c-.3-1.1-1.1-1.5-2.2-1.5H8.5l-.1.4c6.2 1.2 10.2 4.8 11.9 9.2z" fill="#f7a11f" />
      <path
        d="M38.4 15.8h-5l-3.2 18.4h5l3.2-18.4zM23.3 34.3l8-18.4h-5.4L21 28.5l-.5-1.9c-1-2.3-3.7-5.6-7.1-7.6l4.5 15.4 5.4-.1zm29.6-6c0-2.1-1.3-3.7-4.2-5-1.8-.9-2.8-1.4-2.8-2.3 0-.8.9-1.6 2.9-1.6 1.3 0 2.6.2 3.8.7l.5.2.7-4c-1.4-.5-3-.8-4.5-.8-5 0-8.6 2.5-8.6 6.1 0 2.7 2.5 4.1 4.4 5 2 .9 2.6 1.5 2.6 2.3 0 1.2-1.6 1.8-3 1.8-2 0-3.1-.3-4.7-1l-.6-.3-.7 4.1c1.2.5 3.3 1 5.7 1 5 .1 8.5-2.4 8.5-6.2zm9.6-5.8s.4-1.1.7-1.8l.3 1.6s1 4.4 1.2 5.3h-4.2c.3-.9 2-5.1 2-5.1zm-3.6 9h6.5c.2.6.6 2.8.6 2.8h4.7l-4.1-18.4h-3.9c-1.2 0-2.1.3-2.6 1.5l-7.6 16.9h5.4s.8-2.3 1-2.8zM75.7 1.3C75 .5 73.9 0 72.8 0H8.3c-1.1 0-2.2.5-3 1.3-.8.8-1.3 1.9-1.3 3 0-1.1.5-2.2 1.3-3S7.2 0 8.3 0h3C9 0 7 1.9 7 4.3v4.4h70V4.3c0-1.1-.5-2.2-1.3-3z"
        fill="#0f9cc0"
      />
      <path
        d="M7 41.3v4.4c0 2.4 2 4.3 4.3 4.3h-3c-1.1 0-2.2-.5-3-1.3S4 46.8 4 45.6c0 1.1.5 2.2 1.3 3 .7.9 1.8 1.4 2.9 1.4h64.4c1.1 0 2.2-.5 3-1.3.8-.8 1.3-1.9 1.3-3v-4.4H7z"
        fill="#f7a11f"
      />
    </g>
  )
}

Visa.propTypes = {
  cordY: PropTypes.any,
  index: PropTypes.any,
}

const AmericanExpress = props => {
  const { index, cordY } = props
  return (
    <g data-testid="amex" transform={`translate(${padding * index},${cordY}) scale(0.963)`}>
      <path
        fill="#3663a1"
        d="M76.7 45.7c0 1.1-.5 2.2-1.3 3s-1.9 1.3-3 1.3H8.6c-1.1 0-2.2-.5-3-1.3s-1.3-1.9-1.3-3V4.4C4.3 2 6.2.1 8.6.1h63.8c1.1 0 2.2.5 3 1.3s1.3 1.9 1.3 3v41.3z"
      />
      <path
        d="M75.4 1.3c-.8-.8-1.9-1.3-3-1.3H11.6C9.3 0 7.3 1.9 7.3 4.3v41.3c0 2.4 2 4.3 4.3 4.3h-3c-.5 0-.9-.1-1.4-.3.5.2.9.4 1.4.4h63.8c1.1 0 2.2-.5 3-1.3.8-.8 1.3-1.9 1.3-3V4.3c0-1.1-.5-2.2-1.3-3zM8.6.1C6.2.1 4.3 2 4.3 4.3c0-1.1.5-2.2 1.3-3C6.4.6 7.5.1 8.6.1zM6.6 49.4c-.2-.1-.3-.2-.4-.3.1.1.2.2.4.3z"
        fill="#3b6fb6"
      />
      <path
        d="M15 20.1h2.1L16 17.3l-1 2.8zm11.4 9.2v1.3h3.7V32h-3.7v1.4h4.1l1.8-2-1.7-2.1h-4.2zm28.4-12l-1.2 2.8h2.3l-1.1-2.8zM36.9 34.2v-5.6l-2.5 2.8 2.5 2.8zm4.9-4.1c-.1-.6-.5-.9-1.1-.9h-2.1V31h2.2c.6 0 1-.3 1-.9zm6.8.8c.2-.1.3-.4.3-.7.1-.3 0-.6-.3-.7-.2-.1-.5-.1-.8-.1h-2V31h2c.3-.1.6-.1.8-.1z"
        fill="#fff"
      />
      <path
        d="M65.7 23h-2.2l-3.1-5.2V23H57l-.6-1.5H53l-.6 1.6h-1.9c-.8 0-1.8-.2-2.4-.8-.6-.6-.9-1.4-.9-2.7 0-1 .2-2 .9-2.8.5-.6 1.4-.8 2.5-.8h1.6v1.5h-1.6c-.6 0-.9.1-1.3.4-.3.3-.5.9-.5 1.6 0 .8.1 1.3.5 1.7.3.3.7.4 1.2.4h.7l2.3-5.4H56l2.8 6.6v-6.6h2.5l2.8 4.8v-4.8h1.7V23h-.1zm-19.1 0h-1.7v-6.9h1.7V23zm-3.3-2.8l.1.1c.2.3.4.7.3 1.2v1.6h-1.5v-.8c0-.4 0-1-.3-1.4-.1-.1-.2-.2-.3-.2-.1-.1-.4-.1-.9-.1h-1.8v2.5h-1.7v-6.9h3.7c.9 0 1.5 0 2 .3s.8.8.8 1.5c0 .8-.5 1.5-1.2 1.8.4.1.6.2.8.4zm-7-2.6h-3.8v1.3h3.7v1.4h-3.7v1.4h3.8v1.5h-5.5v-7h5.5v1.4zM29.5 23h-1.6v-5.4l-.1.2-2.3 5.2h-1.4l-2.4-5.4V23h-3.3l-.7-1.5h-3.3l-.7 1.5h-1.8l2.9-6.9h2.5l2.7 6.6v-6.6h2.6v.1l1.2 2.7.9 2v-.1l2-4.7h2.7V23h.1zm33.3-8.2V16l-.6-1.2h-4.6V16l-.6-1.2h-6.3c-1.1 0-2 .2-2.7.6v-.6h-4.4v.6c-.5-.4-1.1-.6-1.9-.6H25.9l-1.1 2.5-1.1-2.5h-5V16l-.5-1.2h-4.3l-2 4.6-2.3 5v.1h5.1v-.1l.6-1.5h1.3l.6 1.6h5.7v-1.2l.5 1.2h2.8l.5-1.2v1.2h13.6v-2.6h.2c.2 0 .2 0 .2.3v2.2h7.1v-.6c.8.4 1.7.6 2.7.6h2.9l.6-1.6h1.4l.6 1.6h5.7v-1.5l.9 1.5h4.6v-9.6h-4.4z"
        fill="#fff"
      />
      <path
        d="M41.9 19l.1-.1c.1-.2.2-.5.1-.7V18c0-.1-.2-.3-.3-.3-.2-.1-.5-.1-.8-.1h-2v1.6h2c.3 0 .6 0 .8-.1 0-.1 0-.1.1-.1-.1-.1 0-.1 0 0zm27.8 15.1c-.4.4-1.1.7-2.1.7h-3.1v-1.5h3.1c.3 0 .5 0 .7-.2.3-.3.3-.7 0-1-.2-.1-.4-.2-.6-.2-1.6-.1-3.4 0-3.4-2.2 0-.9.5-1.8 1.9-2h3.7v1.7h-3c-.3 0-.5 0-.7.1-.1.1-.2.3-.2.5 0 .3.1.4.4.5.2.1.4.1.6.1h.9c.4 0 .7 0 1.1.2.3.1 1.2.5 1.4 1.6v.4c-.1.4-.3.9-.7 1.3zm-8.4.7h-3.1v-1.5h3.1c.3 0 .5 0 .7-.2.3-.3.3-.7 0-1-.2-.1-.4-.2-.6-.2-1.6-.1-3.4 0-3.4-2.2 0-1 .6-2.1 2.4-2.1h3.2v1.8h-3c-.3 0-.5 0-.7.1s-.2.3-.2.5c0 .3.2.4.4.5.2.1.4.1.6.1h.9c.9 0 1.5.2 1.9.6.3.3.5.8.5 1.5-.1 1.3-1 2-2.7 2.1zm-4.1-5.5h-3.8v1.3h3.7V32h-3.7v1.4h3.8v1.5h-5.5v-7h5.5v1.4zm-6.8 2.9c.2.3.3.7.3 1.3v1.4H49V34c0-.4 0-1.1-.3-1.4-.2-.3-.6-.3-1.2-.3h-1.8v2.6H44v-7h3.7c.8 0 1.5 0 2 .3.6.3.9.9.9 1.6 0 .8-.4 1.5-1.2 1.9.6 0 .9.2 1 .5zm-9.8.1h-2v2.6h-3.2l-1.9-2.2-.1-.1-2.2 2.3h-6.3V28h6.4l1.7 1.9.4.4v-.1l2.1-2.3h5.2c1 0 2.1.2 2.6 1.3.1.2.1.5.1.7 0 2-1.3 2.4-2.8 2.4zm30.9.6c0-.7-.2-1.3-.5-1.9v-4.7h-4.7c-.6 0-1.4.6-1.4.6v-.6h-4.5c-.7 0-1.6.2-2 .6v-.6h-8.1v.6c-.6-.5-1.7-.6-2.2-.6h-5.2v.6c-.5-.5-1.7-.6-2.3-.6h-5.9l-1.4 1.5-1.3-1.6h-8.8v9.9h8.6l1.4-1.4 1.2 1.4h5.5v-2.3h.5c.7 0 1.6 0 2.3-.3v2.7h4.4v-2.6h.2c.3 0 .3 0 .3.3v2.3H61c.9 0 1.8-.2 2.3-.6v.6h4.2c.9 0 1.8-.1 2.4-.5.9-.5 1.5-1.5 1.6-2.6v-.2z"
        fill="#fff"
      />
    </g>
  )
}

AmericanExpress.propTypes = {
  cordY: PropTypes.any,
  index: PropTypes.any,
}

const RoomsToGoFinance = props => {
  const { index, cordY, uniqueId } = props
  return (
    <g data-testid="rtgfinance" transform={`translate(${padding * index},${cordY}) scale(0.3805)`}>
      <linearGradient
        id={`bggrad${uniqueId}`}
        x1="0"
        x2="200.347"
        y1="63.242"
        y2="63.242"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#003b7c" />
        <stop offset="1" stopColor="#0068a5" />
      </linearGradient>
      <path
        fill={`url(#bggrad${uniqueId})`}
        d="M188.3 126.5H12c-6.6 0-12-5.4-12-12V12C0 5.4 5.4 0 12 0h176.3c6.6 0 12 5.4 12 12v102.5c0 6.6-5.4 12-12 12z"
      />
      <g opacity=".35">
        <path
          d="M159.7 126.3c-3.3-3.1-6.1-6.8-7.9-11.1-1.9-4.3-2.8-9-2.7-13.4 0-12.5 7.4-24.3 19.4-29.5 4.3-1.9 9-2.8 13.4-2.7 6.7.2 13.1 2.3 18.4 6.1v-9.4c-4.7-2.5-10-4.1-15.3-4.6-6.5-.6-13.2.3-19.7 3.1-14.1 6.1-22.9 19.4-24.2 33.6-1 10.1 2 20.1 8 28H160c-.1 0-.2 0-.3-.1zM128.3 82.7 88 100.1l2.8 6.5 16.5-7.2 11.8 27.1h8.5l-13.1-30.2 16.6-7.2zM200.3 23.1c-.6.7-1.3 1.3-2 1.9-.2.2-.4.3-.6.5-1.1.9-2.3 1.8-3.5 2.6-.6.4-1.2.8-1.9 1.2-.5.3-1 .5-1.4.7l-1.2.6c-.7.3-1.4.6-2.2.8-.1 0-.2.1-.3.1-3.4 1.2-6.8 1.8-10.3 2-4 .1-7.9-.6-11.6-1.8-.4-.1-.9-.3-1.3-.4-.1 0-.2-.1-.3-.2-1.1-.5-2.2-1-3.3-1.6-.4-.2-.9-.4-1.3-.7-.8-.5-1.6-1-2.3-1.6-.6-.4-1.3-.9-1.9-1.4-.5-.4-.9-.8-1.4-1.3-.8-.7-1.5-1.4-2.2-2.2-.3-.3-.6-.7-.9-1.1-.8-.9-1.5-1.8-2.1-2.8-.3-.4-.5-.9-.8-1.3-.6-.9-1.1-1.9-1.5-2.9-.1-.3-.3-.5-.4-.8-.3-.7-.6-1.4-.8-2.2 0-.1-.1-.2-.1-.3-1.2-3.4-1.8-6.8-2-10.3V0h-8.4c0 1.7.1 3.5.4 5.2 2.1 14.7 11.7 27.9 26.5 33.8 6.8 2.6 13.9 3.3 20.6 2.4 6.8-1 13.2-3.5 18.7-7.4V23.1zM69.3 3.1c-5.2 4.3-9.4 10.1-12 16.8-2.6 6.8-3.3 13.9-2.4 20.6C57 55.2 66.6 68.4 81.4 74.3c6.8 2.6 13.9 3.3 20.6 2.4 14.7-2.1 27.9-11.7 33.8-26.5 5.5-14.8 2.2-31.1-7.4-42.2-2.6-3-5.6-5.8-9.1-8H73.4c-1.5.9-2.8 2-4.1 3.1zm10.9 2.7c.3-.2.7-.3 1-.5.6-.3 1.1-.6 1.7-.9l.9-.3 2.4-.9c.8-.2 1.6-.5 2.3-.7.7-.2 1.5-.3 2.2-.4.9-.1 1.7-.3 2.6-.4.8-.1 1.5-.1 2.3-.1H98c.9 0 1.9.2 2.8.3.6.1 1.2.1 1.8.3 1.2.2 2.5.6 3.7.9.2.1.5.1.7.2.4.1.8.2 1.3.4 2.5 1 4.8 2.3 6.9 3.7.4.3.8.6 1.1.9.6.5 1.3 1 1.9 1.6.4.3.8.6 1.1.9 1.3 1.3 2.6 2.7 3.7 4.3l.1.1c.8 1.2 1.6 2.4 2.3 3.7.2.3.3.6.5.9.3.6.6 1.1.9 1.7.2.4.3.9.5 1.3.1.3.3.7.4 1 1 2.8 1.6 5.7 1.8 8.5 0 .3 0 .5.1.8.1 1.3.1 2.5 0 3.8v.8c-.1 1.2-.3 2.4-.5 3.6-.2.9-.4 1.7-.6 2.6 0 .2-.1.3-.1.5-.3.9-.5 1.9-.8 2.8-3.3 8.6-9.7 14.9-17.4 18.3-.1.1-.2.1-.4.2s-.5.2-.7.3c-.8.3-1.5.6-2.3.9-1.2.4-2.5.7-3.7 1-.3.1-.5.1-.8.1-1.7.3-3.5.5-5.3.6-.5 0-1-.1-1.5-.1-.7 0-1.4 0-2.2-.1-.6 0-1.2-.1-1.8-.2-2.5-.3-5-.9-7.5-1.9-.3-.1-.5-.3-.8-.4-.6-.2-1.1-.5-1.6-.8-1-.5-2-1-2.9-1.5-.3-.2-.5-.3-.8-.5-1.2-.8-2.3-1.6-3.4-2.5-3.8-3.2-6.8-7.3-8.8-11.8 0-.1-.1-.2-.1-.3-.1-.2-.2-.5-.3-.7-.3-.7-.6-1.5-.9-2.3-.4-1.3-.7-2.5-1-3.7-.1-.3-.1-.5-.1-.8-.3-1.7-.5-3.5-.6-5.3 0-.7 0-1.3.1-2v-.8c0-.4.1-.8.1-1.2.3-3 .9-6 2-8.9 1.1-3 2.7-5.6 4.5-7.9.2-.3.5-.6.7-.9l.6-.6c.4-.5.8-1 1.3-1.5 1.2-1.2 2.5-2.3 3.8-3.3.3-.2.5-.4.8-.6 1.3-.8 2.4-1.6 3.6-2.2zM28.1 109.6 0 45.9V66l20.7 46.8zM48.9 40.4c-4-9.1-12.6-15.1-22.7-15.3-4.1 0-9.6 1-19.5 5.4l-6.7 3v8l11.4-5c6.2-2.7 10.1-3.9 15.5-3.6 6 .3 11.9 4.8 14.5 10.7 2.9 6.7 1.8 15.4-5.4 21.3-3 2.5-6.2 3.9-15.6 8.1l40.3 22.3 9.4-4.2-33.2-18.5c14-7.1 16.8-21.3 12-32.2z"
          fill="#fff"
        />
      </g>
      <path
        d="M17 20.6h3.1c1.6 0 2.4.2 3 .4 1.4.7 2.2 2 2.2 3.5 0 1.8-1.3 3.6-3.6 3.7l3.5 4.6h-1.6l-4.2-5.5c1.6 0 2.1 0 2.7-.2 1.3-.4 2-1.5 2-2.6 0-1-.5-2-1.3-2.4-.7-.4-1.3-.4-2.4-.4h-2.2v11.1H17V20.6zm35.6 0h1.9L59 31l4.4-10.4h1.9v12.2h-1.2V21.9l-4.6 10.9h-1.1l-4.5-10.9v10.9h-1.2V20.6zm15.3 8.8c.1 1.6 1.1 2.5 2.5 2.5 1.3 0 2.5-1 2.5-2.4 0-1.9-1.9-2.4-2.7-2.6-1.1-.3-3.2-.8-3.2-3.2 0-1.9 1.5-3.3 3.4-3.3 2 0 3.4 1.6 3.4 3.3h-1.2c0-1.2-1-2.2-2.2-2.2-1.4 0-2.2 1.1-2.2 2.1 0 1.5 1.3 1.8 2.9 2.3 3 .8 3 3.2 3 3.5 0 1.9-1.5 3.6-3.7 3.6-1.6 0-3.7-.9-3.8-3.6h1.3zm12.6-7.7h-2.8v-1.1h6.9v1.1h-2.8v11.1h-1.2V21.7zm26 6.1h6.2c-.2 1.1-.9 2.1-1.8 2.8-.9.7-2 1.1-3.2 1.1-2.8 0-5.1-2.3-5.1-5.1s2.3-5.1 5.1-5.1c.8 0 1.6.2 2.3.6.7.4 1.3.9 1.8 1.5h1.5c-1.1-2-3.2-3.3-5.5-3.3-3.5 0-6.3 2.9-6.3 6.3s2.9 6.3 6.3 6.3c3.5.1 6.4-2.7 6.4-6.2h-7.6v1.1zm-68.3-2.9a6.307 6.307 0 0 0-7.8-4.3c-1 .3-1.9.8-2.7 1.6s-1.3 1.7-1.6 2.7c-.6 2.2-.1 4.6 1.6 6.3.8.8 1.7 1.3 2.7 1.6 2.2.6 4.6.1 6.3-1.6 1.7-1.7 2.2-4.2 1.5-6.3m-2.4 5.4c-1.5 1.5-3.5 1.8-5.4 1.1-.7-.2-1.3-.6-1.8-1.1-1.5-1.5-1.8-3.5-1.1-5.4.2-.7.6-1.3 1.1-1.8.5-.5 1.1-.9 1.8-1.1 1.8-.7 3.9-.3 5.4 1.1.5.5.9 1.1 1.1 1.8.7 1.8.3 3.9-1.1 5.4m15.7-5.4c-.3-1-.8-1.9-1.6-2.7-1.7-1.7-4.1-2.2-6.3-1.6-1 .3-1.9.8-2.7 1.6s-1.3 1.7-1.6 2.7c-.6 2.2-.1 4.6 1.6 6.3.8.8 1.7 1.3 2.7 1.6 2.2.6 4.6.1 6.3-1.6 1.7-1.7 2.2-4.2 1.6-6.3M49 30.3c-1.5 1.5-3.5 1.8-5.4 1.1-.7-.2-1.3-.6-1.8-1.1-1.5-1.5-1.8-3.5-1.1-5.4.2-.7.6-1.3 1.1-1.8.5-.5 1.1-.9 1.8-1.1 1.8-.7 3.9-.3 5.4 1.1.5.5.9 1.1 1.1 1.8.7 1.8.3 3.9-1.1 5.4m45-9.2c-.9-.5-1.9-.8-3-.8-2.4 0-4.5 1.3-5.5 3.3-1 1.9-1 4.2 0 6 1.1 2 3.2 3.3 5.5 3.3 1.1 0 2.1-.3 3-.8 2-1.1 3.3-3.2 3.3-5.5S96 22.2 94 21.1m-.9 10.2c-.7.3-1.3.4-2.1.4-2 0-3.8-1.2-4.6-3-.3-.7-.4-1.3-.4-2.1 0-.7.2-1.5.4-2.1.8-1.8 2.6-3 4.6-3 .7 0 1.5.2 2.1.4 1.8.8 3 2.6 3 4.6-.1 2.3-1.3 4-3 4.8m33.6-7.6c-1.1-2-3.2-3.3-5.5-3.3-1.1 0-2.1.3-3 .8-2 1.1-3.3 3.2-3.3 5.5s1.3 4.5 3.3 5.5c.9.5 1.9.8 3 .8 2.4 0 4.5-1.3 5.5-3.3.5-.9.8-1.9.8-3s-.3-2.1-.8-3m-1 5.1c-.8 1.8-2.6 3-4.6 3-.7 0-1.5-.2-2.1-.4-1.8-.8-3-2.6-3-4.6s1.2-3.8 3-4.6c.7-.3 1.3-.4 2.1-.4 2 0 3.8 1.2 4.6 3 .3.7.4 1.3.4 2.1.1.6-.1 1.2-.4 1.9"
        fill="#fff"
      />
      <path
        d="M37.3 26.7c0 2.8-2.3 5.1-5.1 5.1-.7 0-1.3-.1-1.9-.4-1.8-.8-3.1-2.6-3.1-4.7 0-.7.1-1.3.4-1.9.5-1.2 1.5-2.2 2.7-2.7.6-.2 1.2-.4 1.9-.4 2.1 0 3.9 1.3 4.7 3.1.2.5.4 1.2.4 1.9zM50.4 26.7c0 2.8-2.3 5.1-5.1 5.1-.7 0-1.3-.1-1.9-.4-1.8-.8-3.1-2.6-3.1-4.7 0-.7.1-1.3.4-1.9.5-1.2 1.5-2.2 2.7-2.7.6-.2 1.2-.4 1.9-.4 2.1 0 3.9 1.3 4.7 3.1.3.5.4 1.2.4 1.9z"
        fill="#ffc600"
      />
      <path
        fill="#c00d03"
        d="M96 26.7c0 2.1-1.3 3.9-3.1 4.7-.6.2-1.2.4-1.9.4-2.1 0-3.9-1.3-4.7-3.1-.2-.6-.4-1.2-.4-1.9s.1-1.3.4-1.9c.8-1.8 2.6-3.1 4.7-3.1.7 0 1.3.1 1.9.4 1.8.6 3.1 2.4 3.1 4.5z"
      />
      <path
        fill="#169162"
        d="M125.9 24.7c-.8-1.9-2.6-3.2-4.8-3.2-.7 0-1.4.1-2 .4-1.9.8-3.2 2.6-3.2 4.8 0 2.1 1.3 4 3.2 4.8.6.2 1.3.4 2 .4 2.2 0 4-1.3 4.8-3.2.1-.3.2-.6.3-1 0-.3.1-.7.1-1 0-.7-.1-1.4-.4-2z"
      />
      <path
        d="M130.8 33V20.4l6.4 6.3-6.4 6.3zM128 20.5c.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7.1-.2.4-.3.7-.3zm1.2 1c0-.3-.1-.6-.4-.9s-.5-.4-.9-.4-.6.1-.9.4c-.2.2-.4.5-.4.9 0 .3.1.6.4.9.2.2.5.4.9.4.3 0 .6-.1.9-.4.3-.3.4-.5.4-.9zm-.9-.2c0 .1 0 .2-.1.2h-.4V21h.5v.3zm-.8-.4v1.3h.2v-.5h.4c.1 0 .1.1.1.3v.2h.2V22c0-.1 0-.1-.1-.2 0-.1-.1-.1-.2-.1.1 0 .1 0 .2-.1.1 0 .1-.1.1-.2 0-.2-.1-.3-.2-.3h-.4c.2-.2-.3-.2-.3-.2z"
        fill="#fff"
      />
    </g>
  )
}

RoomsToGoFinance.propTypes = {
  cordY: PropTypes.any,
  index: PropTypes.any,
  uniqueId: PropTypes.string,
}

const GiftCard = ({ index, cordY, uniqueId }) => (
  <g data-testid="rtggift" transform={`translate(${padding * index},${cordY}) scale(0.3805)`}>
    <linearGradient id={`bggrad${uniqueId}`} x1="0" x2="200.347" y1="63.242" y2="63.242" gradientUnits="userSpaceOnUse">
      <stop offset="0" stopColor="#645ea6" />
      <stop offset="1" stopColor="#b7a8d0" />
    </linearGradient>
    <path
      fill={`url(#bggrad${uniqueId})`}
      d="M188.3 126.5H12c-6.6 0-12-5.4-12-12V12C0 5.4 5.4 0 12 0h176.3c6.6 0 12 5.4 12 12v102.5c0 6.6-5.4 12-12 12z"
    />
    <g opacity=".35">
      <path
        d="M159.7 126.3c-3.3-3.1-6.1-6.8-7.9-11.1-1.9-4.3-2.8-9-2.7-13.4 0-12.5 7.4-24.3 19.4-29.5 4.3-1.9 9-2.8 13.4-2.7 6.7.2 13.1 2.3 18.4 6.1v-9.4c-4.7-2.5-10-4.1-15.3-4.6-6.5-.6-13.2.3-19.7 3.1-14.1 6.1-22.9 19.4-24.2 33.6-1 10.1 2 20.1 8 28H160c-.1 0-.2 0-.3-.1zM128.3 82.7 88 100.1l2.8 6.5 16.5-7.2 11.8 27.1h8.5l-13.1-30.2 16.6-7.2zM200.3 23.1c-.6.7-1.3 1.3-2 1.9-.2.2-.4.3-.6.5-1.1.9-2.3 1.8-3.5 2.6-.6.4-1.2.8-1.9 1.2-.5.3-1 .5-1.4.7l-1.2.6c-.7.3-1.4.6-2.2.8-.1 0-.2.1-.3.1-3.4 1.2-6.8 1.8-10.3 2-4 .1-7.9-.6-11.6-1.8-.4-.1-.9-.3-1.3-.4-.1 0-.2-.1-.3-.2-1.1-.5-2.2-1-3.3-1.6-.4-.2-.9-.4-1.3-.7-.8-.5-1.6-1-2.3-1.6-.6-.4-1.3-.9-1.9-1.4-.5-.4-.9-.8-1.4-1.3-.8-.7-1.5-1.4-2.2-2.2-.3-.3-.6-.7-.9-1.1-.8-.9-1.5-1.8-2.1-2.8-.3-.4-.5-.9-.8-1.3-.6-.9-1.1-1.9-1.5-2.9-.1-.3-.3-.5-.4-.8-.3-.7-.6-1.4-.8-2.2 0-.1-.1-.2-.1-.3-1.2-3.4-1.8-6.8-2-10.3V0h-8.4c0 1.7.1 3.5.4 5.2 2.1 14.7 11.7 27.9 26.5 33.8 6.8 2.6 13.9 3.3 20.6 2.4 6.8-1 13.2-3.5 18.7-7.4V23.1zM69.3 3.1c-5.2 4.3-9.4 10.1-12 16.8-2.6 6.8-3.3 13.9-2.4 20.6C57 55.2 66.6 68.4 81.4 74.3c6.8 2.6 13.9 3.3 20.6 2.4 14.7-2.1 27.9-11.7 33.8-26.5 5.5-14.8 2.2-31.1-7.4-42.2-2.6-3-5.6-5.8-9.1-8H73.4c-1.5.9-2.8 2-4.1 3.1zm10.9 2.7c.3-.2.7-.3 1-.5.6-.3 1.1-.6 1.7-.9l.9-.3 2.4-.9c.8-.2 1.6-.5 2.3-.7.7-.2 1.5-.3 2.2-.4.9-.1 1.7-.3 2.6-.4.8-.1 1.5-.1 2.3-.1H98c.9 0 1.9.2 2.8.3.6.1 1.2.1 1.8.3 1.2.2 2.5.6 3.7.9.2.1.5.1.7.2.4.1.8.2 1.3.4 2.5 1 4.8 2.3 6.9 3.7.4.3.8.6 1.1.9.6.5 1.3 1 1.9 1.6.4.3.8.6 1.1.9 1.3 1.3 2.6 2.7 3.7 4.3l.1.1c.8 1.2 1.6 2.4 2.3 3.7.2.3.3.6.5.9.3.6.6 1.1.9 1.7.2.4.3.9.5 1.3.1.3.3.7.4 1 1 2.8 1.6 5.7 1.8 8.5 0 .3 0 .5.1.8.1 1.3.1 2.5 0 3.8v.8c-.1 1.2-.3 2.4-.5 3.6-.2.9-.4 1.7-.6 2.6 0 .2-.1.3-.1.5-.3.9-.5 1.9-.8 2.8-3.3 8.6-9.7 14.9-17.4 18.3-.1.1-.2.1-.4.2s-.5.2-.7.3c-.8.3-1.5.6-2.3.9-1.2.4-2.5.7-3.7 1-.3.1-.5.1-.8.1-1.7.3-3.5.5-5.3.6-.5 0-1-.1-1.5-.1-.7 0-1.4 0-2.2-.1-.6 0-1.2-.1-1.8-.2-2.5-.3-5-.9-7.5-1.9-.3-.1-.5-.3-.8-.4-.6-.2-1.1-.5-1.6-.8-1-.5-2-1-2.9-1.5-.3-.2-.5-.3-.8-.5-1.2-.8-2.3-1.6-3.4-2.5-3.8-3.2-6.8-7.3-8.8-11.8 0-.1-.1-.2-.1-.3-.1-.2-.2-.5-.3-.7-.3-.7-.6-1.5-.9-2.3-.4-1.3-.7-2.5-1-3.7-.1-.3-.1-.5-.1-.8-.3-1.7-.5-3.5-.6-5.3 0-.7 0-1.3.1-2v-.8c0-.4.1-.8.1-1.2.3-3 .9-6 2-8.9 1.1-3 2.7-5.6 4.5-7.9.2-.3.5-.6.7-.9l.6-.6c.4-.5.8-1 1.3-1.5 1.2-1.2 2.5-2.3 3.8-3.3.3-.2.5-.4.8-.6 1.3-.8 2.4-1.6 3.6-2.2zM28.1 109.6 0 45.9V66l20.7 46.8zM48.9 40.4c-4-9.1-12.6-15.1-22.7-15.3-4.1 0-9.6 1-19.5 5.4l-6.7 3v8l11.4-5c6.2-2.7 10.1-3.9 15.5-3.6 6 .3 11.9 4.8 14.5 10.7 2.9 6.7 1.8 15.4-5.4 21.3-3 2.5-6.2 3.9-15.6 8.1l40.3 22.3 9.4-4.2-33.2-18.5c14-7.1 16.8-21.3 12-32.2z"
        fill="#fff"
      />
    </g>
    <path
      d="M17 20.6h3.1c1.6 0 2.4.2 3 .4 1.4.7 2.2 2 2.2 3.5 0 1.8-1.3 3.6-3.6 3.7l3.5 4.6h-1.6l-4.2-5.5c1.6 0 2.1 0 2.7-.2 1.3-.4 2-1.5 2-2.6 0-1-.5-2-1.3-2.4-.7-.4-1.3-.4-2.4-.4h-2.2v11.1H17V20.6zm35.6 0h1.9L59 31l4.4-10.4h1.9v12.2h-1.2V21.9l-4.6 10.9h-1.1l-4.5-10.9v10.9h-1.2V20.6zm15.3 8.8c.1 1.6 1.1 2.5 2.5 2.5 1.3 0 2.5-1 2.5-2.4 0-1.9-1.9-2.4-2.7-2.6-1.1-.3-3.2-.8-3.2-3.2 0-1.9 1.5-3.3 3.4-3.3 2 0 3.4 1.6 3.4 3.3h-1.2c0-1.2-1-2.2-2.2-2.2-1.4 0-2.2 1.1-2.2 2.1 0 1.5 1.3 1.8 2.9 2.3 3 .8 3 3.2 3 3.5 0 1.9-1.5 3.6-3.7 3.6-1.6 0-3.7-.9-3.8-3.6h1.3zm12.6-7.7h-2.8v-1.1h6.9v1.1h-2.8v11.1h-1.2V21.7zm26 6.1h6.2c-.2 1.1-.9 2.1-1.8 2.8-.9.7-2 1.1-3.2 1.1-2.8 0-5.1-2.3-5.1-5.1s2.3-5.1 5.1-5.1c.8 0 1.6.2 2.3.6.7.4 1.3.9 1.8 1.5h1.5c-1.1-2-3.2-3.3-5.5-3.3-3.5 0-6.3 2.9-6.3 6.3s2.9 6.3 6.3 6.3c3.5.1 6.4-2.7 6.4-6.2h-7.6v1.1zm-68.3-2.9a6.307 6.307 0 0 0-7.8-4.3c-1 .3-1.9.8-2.7 1.6s-1.3 1.7-1.6 2.7c-.6 2.2-.1 4.6 1.6 6.3.8.8 1.7 1.3 2.7 1.6 2.2.6 4.6.1 6.3-1.6 1.7-1.7 2.2-4.2 1.5-6.3m-2.4 5.4c-1.5 1.5-3.5 1.8-5.4 1.1-.7-.2-1.3-.6-1.8-1.1-1.5-1.5-1.8-3.5-1.1-5.4.2-.7.6-1.3 1.1-1.8.5-.5 1.1-.9 1.8-1.1 1.8-.7 3.9-.3 5.4 1.1.5.5.9 1.1 1.1 1.8.7 1.8.3 3.9-1.1 5.4m15.7-5.4c-.3-1-.8-1.9-1.6-2.7-1.7-1.7-4.1-2.2-6.3-1.6-1 .3-1.9.8-2.7 1.6s-1.3 1.7-1.6 2.7c-.6 2.2-.1 4.6 1.6 6.3.8.8 1.7 1.3 2.7 1.6 2.2.6 4.6.1 6.3-1.6 1.7-1.7 2.2-4.2 1.6-6.3M49 30.3c-1.5 1.5-3.5 1.8-5.4 1.1-.7-.2-1.3-.6-1.8-1.1-1.5-1.5-1.8-3.5-1.1-5.4.2-.7.6-1.3 1.1-1.8.5-.5 1.1-.9 1.8-1.1 1.8-.7 3.9-.3 5.4 1.1.5.5.9 1.1 1.1 1.8.7 1.8.3 3.9-1.1 5.4m45-9.2c-.9-.5-1.9-.8-3-.8-2.4 0-4.5 1.3-5.5 3.3-1 1.9-1 4.2 0 6 1.1 2 3.2 3.3 5.5 3.3 1.1 0 2.1-.3 3-.8 2-1.1 3.3-3.2 3.3-5.5S96 22.2 94 21.1m-.9 10.2c-.7.3-1.3.4-2.1.4-2 0-3.8-1.2-4.6-3-.3-.7-.4-1.3-.4-2.1 0-.7.2-1.5.4-2.1.8-1.8 2.6-3 4.6-3 .7 0 1.5.2 2.1.4 1.8.8 3 2.6 3 4.6-.1 2.3-1.3 4-3 4.8m33.6-7.6c-1.1-2-3.2-3.3-5.5-3.3-1.1 0-2.1.3-3 .8-2 1.1-3.3 3.2-3.3 5.5s1.3 4.5 3.3 5.5c.9.5 1.9.8 3 .8 2.4 0 4.5-1.3 5.5-3.3.5-.9.8-1.9.8-3s-.3-2.1-.8-3m-1 5.1c-.8 1.8-2.6 3-4.6 3-.7 0-1.5-.2-2.1-.4-1.8-.8-3-2.6-3-4.6s1.2-3.8 3-4.6c.7-.3 1.3-.4 2.1-.4 2 0 3.8 1.2 4.6 3 .3.7.4 1.3.4 2.1.1.6-.1 1.2-.4 1.9"
      fill="#fff"
    />
    <path
      d="M37.3 26.7c0 2.8-2.3 5.1-5.1 5.1-.7 0-1.3-.1-1.9-.4-1.8-.8-3.1-2.6-3.1-4.7 0-.7.1-1.3.4-1.9.5-1.2 1.5-2.2 2.7-2.7.6-.2 1.2-.4 1.9-.4 2.1 0 3.9 1.3 4.7 3.1.2.5.4 1.2.4 1.9zM50.4 26.7c0 2.8-2.3 5.1-5.1 5.1-.7 0-1.3-.1-1.9-.4-1.8-.8-3.1-2.6-3.1-4.7 0-.7.1-1.3.4-1.9.5-1.2 1.5-2.2 2.7-2.7.6-.2 1.2-.4 1.9-.4 2.1 0 3.9 1.3 4.7 3.1.3.5.4 1.2.4 1.9z"
      fill="#ffc600"
    />
    <path
      fill="#c00d03"
      d="M96 26.7c0 2.1-1.3 3.9-3.1 4.7-.6.2-1.2.4-1.9.4-2.1 0-3.9-1.3-4.7-3.1-.2-.6-.4-1.2-.4-1.9s.1-1.3.4-1.9c.8-1.8 2.6-3.1 4.7-3.1.7 0 1.3.1 1.9.4 1.8.6 3.1 2.4 3.1 4.5z"
    />
    <path
      fill="#169162"
      d="M125.9 24.7c-.8-1.9-2.6-3.2-4.8-3.2-.7 0-1.4.1-2 .4-1.9.8-3.2 2.6-3.2 4.8 0 2.1 1.3 4 3.2 4.8.6.2 1.3.4 2 .4 2.2 0 4-1.3 4.8-3.2.1-.3.2-.6.3-1 0-.3.1-.7.1-1 0-.7-.1-1.4-.4-2z"
    />
    <path
      d="M130.8 33V20.4l6.4 6.3-6.4 6.3zM128 20.5c.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3-.2-.2-.3-.4-.3-.7 0-.3.1-.5.3-.7.1-.2.4-.3.7-.3zm1.2 1c0-.3-.1-.6-.4-.9s-.5-.4-.9-.4-.6.1-.9.4c-.2.2-.4.5-.4.9 0 .3.1.6.4.9.2.2.5.4.9.4.3 0 .6-.1.9-.4.3-.3.4-.5.4-.9zm-.9-.2c0 .1 0 .2-.1.2h-.4V21h.5v.3zm-.8-.4v1.3h.2v-.5h.4c.1 0 .1.1.1.3v.2h.2V22c0-.1 0-.1-.1-.2 0-.1-.1-.1-.2-.1.1 0 .1 0 .2-.1.1 0 .1-.1.1-.2 0-.2-.1-.3-.2-.3h-.4c.2-.2-.3-.2-.3-.2z"
      fill="#fff"
    />
  </g>
)

GiftCard.propTypes = {
  cordY: PropTypes.any,
  index: PropTypes.any,
  uniqueId: PropTypes.string,
}

const PayPal = props => {
  const { index, cordY } = props
  return (
    <g data-testid="paypal" transform={`translate(${padding * index},${cordY}) scale(0.963)`}>
      <path
        fill="#96d9ee"
        d="M77 45.6c0 1.1-.5 2.2-1.3 3-.8.8-1.9 1.2-3 1.2H8.3c-1.1 0-2.2-.4-3-1.2-.8-.8-1.3-1.9-1.3-3V4.4c0-1.1.5-2.2 1.3-3S7.2.2 8.3.2h64.3c1.1 0 2.2.4 3 1.2s1.3 1.9 1.3 3c.1 0 .1 41.2.1 41.2z"
      />
      <path
        fill="#223f80"
        d="M51.5 9.9c-1.6-1.8-4.5-2.7-8.7-2.7H31.3c-.7 0-1.4.7-1.6 1.4l-4.5 29.8c0 .7.5 1.1.9 1.1h7.1L35 28.3v.5c.2-.7.9-1.4 1.6-1.4H40c6.7 0 11.6-2.7 13.2-10.2v-.7c.3-3-.2-4.8-1.7-6.6"
      />
      <path
        fill="#242f65"
        d="M53.3 17.1v-.8c-.3-.2-.7-.4-1.1-.6-1.1-.4-2.3-.7-3.4-.7H38.5c-1.2 0-1.5 1-1.6 1.4l-1.8 11.7v.5c.2-.7.9-1.4 1.6-1.4h3.4c6.6.1 11.6-2.6 13.2-10.1z"
      />
      <path
        fill="#1c9ad6"
        d="M55.5 19.2c-.4-1.2-1.2-2.2-2.2-2.9v.8c-1.6 7.5-6.7 10.2-13.2 10.2h-3.4c-.7 0-1.4.7-1.6 1.4v-.2c0 .1 0 .1-.1.2l-1.3 7.8-.5 2.8-.5 3.2c0 .5.2.9.9.9h5.6c1.1 0 1.5-.9 1.6-1.4v-.3l1.1-6.7s.1-1.6 1.7-1.6h.6c5.7 0 10.3-2.3 11.4-9.1.4-1.9.4-3.7-.1-5.1z"
      />
      <path
        fill="#82b1bf"
        d="M7 45.7V4.3C7 1.9 9 0 11.4 0h-3c-1.1 0-2.2.5-3 1.3S4 3.2 4 4.3v41.4c0 1.1.5 2.2 1.3 3 .8.8 1.9 1.3 3 1.3h3C9 50 7 48.1 7 45.7z"
      />
    </g>
  )
}

PayPal.propTypes = {
  cordY: PropTypes.any,
  index: PropTypes.any,
}

const Klarna = props => {
  const { index, cordY } = props
  return (
    <g data-testid="klarna" transform={`translate(${padding * index},${cordY}) scale(0.963)`}>
      <path
        fill="#ffb3c7"
        d="M9.606 1.414h68.758A8.179 8.179 0 0 1 86.55 9.6v30.912a8.179 8.179 0 0 1-8.186 8.185H9.606a8.179 8.179 0 0 1-8.186-8.185V9.6c.097-4.526 3.756-8.186 8.186-8.186z"
      />
      <path
        fill="#0a0b09"
        d="M78.557 29.052c-1.156 0-2.022.867-2.022 2.022 0 1.156.866 2.023 2.022 2.023 1.155 0 2.022-.867 2.022-2.022 0-1.06-.867-2.023-2.022-2.023zm-6.645-1.54c0-1.541-1.348-2.793-2.889-2.793s-2.889 1.252-2.889 2.792 1.348 2.793 2.89 2.793 2.888-1.252 2.888-2.793zm0-5.393h3.178v10.785h-3.178v-.674c-.963.674-2.022.963-3.178.963-3.081 0-5.681-2.6-5.681-5.682s2.503-5.681 5.681-5.681c1.156 0 2.311.385 3.178.963v-.674zm-25.616 1.348v-1.348h-3.274v10.785h3.274V27.8c0-1.733 1.83-2.6 3.082-2.6V22.12c-1.252 0-2.504.481-3.082 1.348zm-8.185 4.044c0-1.54-1.348-2.792-2.89-2.792s-2.888 1.252-2.888 2.792 1.348 2.793 2.889 2.793 2.889-1.252 2.889-2.793zm0-5.392h3.178v10.785H38.11v-.674a5.888 5.888 0 0 1-3.178.963c-3.082 0-5.682-2.6-5.682-5.682s2.504-5.681 5.682-5.681c1.156 0 2.311.385 3.178.963v-.674zm19.26-.29c-1.252 0-2.504.386-3.274 1.541V22.12h-3.178v10.785h3.274v-5.682c0-1.637 1.06-2.407 2.407-2.407 1.445 0 2.215.867 2.215 2.407v5.682h3.178v-6.933c0-2.504-2.022-4.141-4.622-4.141zM24.533 32.905h3.37V17.207h-3.37v15.697zm-14.734 0h3.563V17.207H9.799v15.697zM22.22 17.207c0 3.37-1.348 6.549-3.66 8.86l4.912 6.74h-4.43l-5.296-7.318 1.348-1.06c2.311-1.733 3.563-4.429 3.563-7.222h3.563z"
      />
    </g>
  )
}

Klarna.propTypes = {
  cordY: PropTypes.any,
  index: PropTypes.any,
}

const AffirmFinance = props => {
  const { index, cordY } = props
  const addPadding = padding + 1
  return (
    <g data-testid="affirm" transform={`translate(${addPadding * index},${cordY}) scale(0.963)`}>
      <path
        fill="#0c0e0e"
        d="M35.7 39.8h3.6V27.3h-3.6v12.5zm-2.2-12.5h-3.2V26c0-1.7.9-2.1 1.8-2.1.6 0 1.1.1 1.6.4l1.1-2.5s-1.1-.7-3.2-.7c-2.3 0-4.9 1.3-4.9 5.3v.9h-5.4V26c0-1.7.9-2.1 1.8-2.1.6 0 1.1.1 1.6.4l1.1-2.5c-.7-.4-1.7-.7-3.2-.7-2.3 0-4.9 1.3-4.9 5.3v.9h-2.1v2.8h2.1v9.8h3.6v-9.8h5.4v9.8h3.6v-9.8h3.2v-2.8zm34.1-.3c-1.9 0-3.3 1.1-4 2.2-.7-1.4-2.1-2.2-3.9-2.2-1.9 0-3.2 1.1-3.8 2.3v-1.9h-3.5v12.5H56v-6.5c0-2.3 1.2-3.4 2.3-3.4 1 0 2 .7 2 2.4v7.5h3.6v-6.5c0-2.3 1.2-3.4 2.4-3.4.9 0 1.9.7 1.9 2.3v7.5h3.6V31c-.1-2.7-2-4.1-4.2-4m-25.4.2v12.5h3.6v-6c0-2.9 1.7-3.7 2.9-3.7.5 0 1.1.1 1.5.5l.7-3.3c-.5-.2-1.1-.3-1.6-.3-1.8 0-3 .8-3.8 2.5v-2.1h-3.3v-.1zm-33.5-.3c-2.1 0-4.4 1-5.7 2l1.2 2.5c1-.9 2.7-1.8 4.2-1.8 1.4 0 2.2.5 2.2 1.4 0 .7-.5 1-1.5 1.1-3.7.5-6.6 1.5-6.6 4.4 0 2.3 1.6 3.6 4.1 3.6 1.8 0 3.4-1 4.2-2.3v1.9h3.3v-8.2c0-3.2-2.4-4.5-5.4-4.6M7.4 37.6c-.9 0-1.4-.5-1.4-1.2 0-1.4 1.6-1.9 4.5-2.2 0 1.9-1.3 3.4-3.1 3.4"
      />
      <path
        fill="#359dd7"
        d="M56.5 9.9c-9.7 0-18.3 6.7-20.7 15.3h3.5c2-6.4 9-12.1 17.2-12.1 10 0 18.7 7.6 18.7 19.5 0 2.7-.3 5.1-1 7.2h3.4v-.1c.6-2.3.9-4.7.8-7.1.1-13.2-9.6-22.7-21.9-22.7"
      />
    </g>
  )
}

AffirmFinance.propTypes = {
  cordY: PropTypes.any,
  index: PropTypes.any,
}

const BitPay = ({ index, cordY, cards }) => {
  const singleCordY = cards ? cordY : 20
  const addPadding = padding + 1
  return (
    <g data-testid="bitpay" transform={`translate(${addPadding * index},${singleCordY}) scale(0.45)`}>
      <path
        fill="#fff"
        d="M3.7.6h164.9c.7 0 1.2 0 1.6.1.4.1.7.2.9.4.4.4.8 1 1 1.7.1.4.2.9.2 1.6v56.5c0 .7-.1 1.2-.2 1.6-.2.7-.5 1.3-1 1.7-.2.2-.5.3-.9.4-.4.1-.9.1-1.6.1H3.7c-.7 0-1.2 0-1.6-.1-.4-.1-.7-.2-.9-.4-.4-.4-.8-1-1-1.7-.1-.4-.2-.9-.2-1.6V4.3c0-.7.1-1.2.2-1.6.3-.7.6-1.3 1-1.7.2-.2.5-.3.9-.4h1.6z"
      />
      <path
        fill="#1a3b8b"
        d="M168.6 65H3.7c-.7 0-1.2 0-1.7-.1s-.9-.2-1.2-.5c-.5-.4-.9-1.1-1.1-2-.1-.4-.2-.9-.2-1.7V4.3c0-.8.1-1.3.2-1.7.2-.8.6-1.5 1.1-2C1.2.3 1.5.2 2 .1 2.5 0 3 0 3.7 0h164.9c.7 0 1.3 0 1.7.1.5.1.9.2 1.2.5.5.4.9 1.1 1.1 2 .1.4.2.9.2 1.7v56.5c0 .8-.1 1.3-.2 1.7-.2.8-.6 1.5-1.1 2-.3.3-.7.4-1.2.5h-1.7zM3.7 1.1c-.7 0-1.2 0-1.6.1-.3 0-.4.1-.6.2-.3.3-.6.8-.8 1.4-.1.4-.1.8-.2 1.5v56.5c0 .7.1 1.1.2 1.5.2.6.5 1.2.8 1.5.1.1.2.2.6.2.4.1.9.1 1.6.1h164.9c.7 0 1.2 0 1.6-.1.4-.1.5-.1.6-.2.3-.3.6-.8.8-1.5.1-.4.2-.8.2-1.5V4.3c0-.7-.1-1.1-.2-1.5-.2-.6-.5-1.2-.8-1.5-.1-.1-.2-.2-.6-.2-.4-.1-.9-.1-1.6-.1H3.7z"
      />
      <path
        fill="#1a3b8b"
        d="M.2 1.2C0 1.7 0 2.3 0 3.6v57.8c0 1.3 0 1.9.2 2.4.2.4.6.8 1 1 .5.2 1.1.2 2.4.2h83.6c1.3 0 1.9 0 2.4-.2.4-.2.8-.6 1-1 .2-.5.2-1.1.2-2.4V38.2l-6.7-5.7 6.7-5.1V3.6c0-1.3 0-1.9-.2-2.4-.2-.4-.6-.8-1-1-.5-.2-1.2-.2-2.4-.2H3.6C2.3 0 1.7 0 1.2.2c-.4.3-.7.6-1 1z"
      />
      <path
        fill="#fff"
        d="M80.1 25.7h-3.7L74.2 35l-.3 1.3c-.2.1-.4.1-.6.2-.4.1-.8.1-1.2.1-.5 0-.9-.1-1.1-.2-.3-.1-.5-.3-.6-.6-.1-.3-.2-.6-.1-.9 0-.3.1-.7.2-1.1l1.1-4.8.7-3.2h-3.8l-1.7 7.4c-.2.9-.3 1.7-.4 2.6 0 .8.1 1.5.4 2.2.3.6.7 1.1 1.4 1.5.6.4 1.6.5 2.7.5.8 0 1.5-.1 2.1-.2h.1c-.2.8-.5 1.4-1 1.9s-1.3.7-2.4.7c-.5 0-.9 0-1.2-.1l-.7 3.2c.5.1 1 .1 1.6.1 1.1 0 2.1-.1 3-.4.9-.3 1.6-.7 2.2-1.2.6-.5 1.1-1.2 1.5-2 .4-.8.7-1.8 1-2.9L79.7 28l.4-2.3zm-15.6 8c-.2 1-.3 2-.2 2.9.1 1 .5 2.5.8 3.2h-3.6c-.4-.8-.4-1.1-.5-1.4-.5.4-1 .7-1.6 1-.6.3-1.2.4-1.9.4-.8 0-1.6-.2-2.1-.4-.6-.3-1.1-.7-1.5-1.2-.4-.5-.6-1.1-.8-1.8-.2-.7-.2-1.4-.2-2.2 0-1.2.2-2.3.6-3.3.4-1 1-2 1.7-2.7.7-.8 2.5-2.5 5.4-2.5h5.8l-1.9 8zm-2.6-4.8c-1.7 0-2.1 0-2.8.4-.5.3-.9.7-1.3 1.1-.4.5-.7 1-.9 1.6-.2.6-.3 1.3-.3 1.9 0 .8.1 1.5.4 2 .3.5.8.7 1.5.7.4 0 .7-.1 1-.2.3-.2.6-.4 1-.8 0-.4.1-.9.2-1.3.1-.5.2-.9.2-1.3l1-4.1zm-10 2.4c0 1.3-.2 2.4-.6 3.4-.4 1-1 1.9-1.7 2.7-.7.8-1.6 1.3-2.6 1.8-1 .4-2.1.6-3.3.6-.6 0-1.1-.1-1.7-.2l-1.1 4.7h-3.7l4.3-18.6h5c.9 0 1.8.2 2.4.4.7.3 1.2.7 1.7 1.2.4.5.8 1.1 1 1.8.2.7.3 1.4.3 2.2zm-9.2 5.3c.3.1.6.1 1.1.1.7 0 1.2-.1 1.8-.4.5-.3 1-.6 1.4-1 .4-.4.7-1 .9-1.6.2-.6.3-1.3.3-2.1 0-.7-.2-1.4-.5-1.9s-.9-.8-1.7-.8h-1.5l-1.8 7.7zm-7.8 0c-.5 0-.9-.1-1.1-.2-.3-.1-.5-.3-.6-.6-.1-.3-.2-.6-.1-.9 0-.3.1-.7.2-1.1l1.1-4.8h4.2l.8-3.2h-4.3l1-4.1-4 .6-2.5 10.9c-.2.9-.3 1.7-.4 2.6 0 .8.1 1.5.4 2.2.3.6.7 1.1 1.4 1.5.6.4 1.6.5 2.7.5.8 0 1.5-.1 2.1-.2.1 0 .2 0 .2-.1l.8-3.3c-.3.1-.5.2-.8.2h-1.1zm-9.5-10.9-3.3 14.1h3.7l3.3-14.1h-3.7zm4.1-1.6.6-2.5h-3.7l-.6 2.5h3.7zm-12.3 1.6c.8 0 1.5.2 2.1.4.6.3 1.1.7 1.5 1.2.4.5.7 1.1.9 1.7.2.7.3 1.4.3 2.2 0 1.2-.2 2.3-.6 3.4-.4 1-1 2-1.7 2.8-.7.8-1.6 1.4-2.6 1.8-1 .4-2.1.7-3.3.7H13c-.4 0-.8 0-1.3-.1l-1.5-.3c-.5-.1-1.1-.3-1.5-.6L13 20.3l3.9-.6-1.5 6.6c.3-.2.6-.3 1-.3 0-.2.4-.3.8-.3zm-3.3 11c.6 0 1.1-.1 1.6-.4.5-.3 1-.7 1.3-1.2.4-.5.7-1 .9-1.6.2-.6.3-1.3.3-1.9 0-.8-.1-1.5-.4-1.9-.3-.5-.8-.7-1.5-.7-.2 0-.5 0-.9.1s-.7.3-1 .5l-1.6 7c.5.1.6.1.8.1h.5z"
      />
      <circle cx="115.5" cy="32.3" r="18.2" fill="#6b71d6" />
      <circle cx="145.4" cy="32.3" r="18.2" fill="#f7931a" />
      <path
        fill="#fff"
        d="M149.7 30.2c-.5 2-3.7 1-4.8.8l.9-3.5c1 .2 4.4.6 3.9 2.7zm-.5 5.8c-.5 2.2-4.4 1.1-5.7.8l1-3.9c1.2.2 5.2.8 4.7 3.1zm4.2-5.8c.3-2.2-1.4-3.3-3.8-4l.7-2.9-1.9-.4-.7 2.9-1.5-.3.7-2.9-1.9-.4-.7 2.9c-.4-.1-.8-.2-1.2-.2l-2.6-.6-.5 1.9s1.4.3 1.3.3c.8.2.9.7.9 1l-.8 3.3s.1 0 .2.1h-.2l-1.1 4.6c-.1.2-.3.5-.8.4l-1.4-.3-.9 2 2.4.5c.4.1.9.2 1.3.3l-.7 2.9 1.9.4.7-2.9c.5.1 1 .2 1.5.4l-.7 2.9 1.9.4.7-2.9c3.2.5 5.5.3 6.5-2.5.8-2.2-.1-3.5-1.8-4.3 1.3-.2 2.2-1 2.5-2.6zm-37.7-9.7c-.1.1-1.7 2.8-3.6 6-1.9 3.2-3.5 5.8-3.5 5.9 0 .1 1 .7 3.6 2.3l3.7 2.2 3.7-2.2c2.6-1.6 3.7-2.2 3.6-2.3-.1-.3-7.3-12.2-7.3-12.2s-.1.1-.2.3m-7 13.5c.1.2 7.2 10.4 7.3 10.3l7.3-10.4s-6.8 4-7.1 4.2l-.2.1-3.5-2.1c-2-1.1-3.6-2.1-3.8-2.1-.1-.1-.1-.1 0 0"
      />
    </g>
  )
}

BitPay.propTypes = {
  cordY: PropTypes.any,
  index: PropTypes.any,
  cards: PropTypes.any,
}

// simple logo w/ bitpay text, no bitcoin/etherium icons to the right
// const BitPaySimple = ({ index, cordY }) => (
//   <g data-testid="bitpay" transform={`translate(${padding * index},${cordY}) scale(1)`}>
//     <image width="175" height="50" xlinkHref={BitPayLogo} />
//   </g>
// )

// BitPaySimple.propTypes = {
//   cordY: PropTypes.any,
//   index: PropTypes.any,
// }

const SVGWrap = ({
  children,
  uniqueNameForId,
  cards,
  width,
  height,
  vpHeight,
  className,
  hidden,
  style,
  title,
  paymentComponents,
}) => {
  const cardCount = cards ? cards.length : Object.keys(paymentComponents).length
  const cardsItem = cards || paymentComponents
  const viewPortHeight = vpHeight || '65'
  const offSet = padding + 1

  const returnCardTitles = () =>
    cards
      ? cardsItem.map(card => paymentComponents[card]?.title)
      : Object.keys(cardsItem).map(card => paymentComponents[card]?.title)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${offSet * cardCount} ${viewPortHeight}`}
      role={hidden ? null : 'img'}
      aria-hidden={hidden ? 'true' : null}
      aria-labelledby={hidden ? null : `paysvgid${uniqueNameForId} paysvgdesc${uniqueNameForId}`}
      preserveAspectRatio="xMidYMid meet"
      width={width}
      height={height}
      className={className}
      style={style}
    >
      {!hidden && (
        <>
          <title id={`paysvgid${uniqueNameForId}`}>{title || 'Credit cards accepted'}</title>
          <desc id={`paysvgdesc${uniqueNameForId}`}>{returnCardTitles()}</desc>
        </>
      )}
      {children}
    </svg>
  )
}

SVGWrap.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  uniqueNameForId: PropTypes.string,
  cards: PropTypes.array,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  vpHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  style: PropTypes.object,
  hidden: PropTypes.bool,
  title: PropTypes.string,
  paymentComponents: PropTypes.object,
}

const klarnaPaymentComp = { title: 'Klarna', comp: Klarna, order: 7 }
const components = {
  discover: { title: 'Discover', comp: Discover, order: 1 },
  mastercard: { title: 'Master Card', comp: MasterCard, order: 2 },
  visa: { title: 'Visa', comp: Visa, order: 3 },
  amex: { title: 'American Express', comp: AmericanExpress, order: 4 },
  rtg: { title: 'Rooms To Go Credit', comp: RoomsToGoFinance, order: 5 },
  paypal: { title: 'PayPal', comp: PayPal, order: 6 },
  affirm: { title: 'Affirm Finance', comp: AffirmFinance, order: 8 },
  bitpay: { title: 'BitPay', comp: BitPay, order: 9 },
}

const PaymentSvg = ({
  uniqueNameForId,
  cards,
  width,
  height,
  vpHeight,
  className,
  hidden,
  cordY,
  style,
  renderGiftCard,
  cart,
}) => {
  const [paymentComponents, setPaymentComponents] = useState(components)

  const passY = cordY || '10'

  useEffect(() => {
    let newPaymentComponentsState = { ...paymentComponents }
    if (!isGiftCardSelected(cart)) {
      newPaymentComponentsState = { ...newPaymentComponentsState, klarna: klarnaPaymentComp }
    }
    if (renderGiftCard) {
      newPaymentComponentsState = { ...newPaymentComponentsState, gift: { title: 'Gift Card', comp: GiftCard } }
    }
    setPaymentComponents(newPaymentComponentsState)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isGiftCardSelected(cart)) {
      delete paymentComponents.klarna
      setPaymentComponents(paymentComponents)
    } else {
      setPaymentComponents({ ...paymentComponents, klarna: klarnaPaymentComp })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart])

  return (
    <SVGWrap
      paymentComponents={paymentComponents}
      uniqueNameForId={uniqueNameForId}
      cards={cards}
      width={width}
      height={height}
      vpHeight={vpHeight}
      className={className}
      style={style}
      hidden={hidden}
      title={renderGiftCard && 'Gift Card'}
    >
      {cards
        ? cards.map((card, index) => {
            const Comp = paymentComponents[card]?.comp
            return Comp && <Comp key={card} cards={cards} index={index} cordY={passY} uniqueId={uniqueNameForId} />
          })
        : Object.keys(paymentComponents)
            .sort((a, b) => paymentComponents[a].order - paymentComponents[b].order)
            .map((card, index) => {
              const Comp = paymentComponents[card]?.comp
              return Comp && <Comp key={card} cards={cards} index={index} cordY={passY} uniqueId={uniqueNameForId} />
            })}
    </SVGWrap>
  )
}

PaymentSvg.propTypes = {
  cart: PropTypes.object,
  uniqueNameForId: PropTypes.string,
  cards: PropTypes.array,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  vpHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  cordY: PropTypes.string,
  style: PropTypes.object,
  hidden: PropTypes.bool,
  renderGiftCard: PropTypes.bool,
}

export default PaymentSvg
